function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M14 6H6V21H14V6ZM17 0C17.8333 0 18.5417 0.291667 19.125 0.875C19.7083 1.45833 20 2.16667 20 3V29C20 29.8333 19.7083 30.5417 19.125 31.125C18.5417 31.7083 17.8333 32 17 32H3C2.16667 32 1.45833 31.7083 0.875 31.125C0.291667 30.5417 0 29.8333 0 29V3C0 2.16667 0.291667 1.45833 0.875 0.875C1.45833 0.291667 2.16667 0 3 0H17ZM3 30H17C17.2917 30 17.5208 29.8958 17.6875 29.6875C17.8958 29.5208 18 29.2917 18 29V3C18 2.70833 17.8958 2.47917 17.6875 2.3125C17.5208 2.10417 17.2917 2 17 2H3C2.70833 2 2.45833 2.10417 2.25 2.3125C2.08333 2.47917 2 2.70833 2 3V29C2 29.2917 2.08333 29.5208 2.25 29.6875C2.45833 29.8958 2.70833 30 3 30ZM15.25 4C15.75 4 16 4.25 16 4.75V22.25C16 22.75 15.75 23 15.25 23H4.75C4.25 23 4 22.75 4 22.25V4.75C4 4.25 4.25 4 4.75 4H15.25ZM12.25 26C12.75 26 13 26.25 13 26.75V27.25C13 27.75 12.75 28 12.25 28H7.75C7.25 28 7 27.75 7 27.25V26.75C7 26.25 7.25 26 7.75 26H12.25Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.20ec2cf35f5adbf5ae361e1a6aeb1bfe.svg";
export { ForwardRef as ReactComponent };